import { ReactElement, useState } from "react";
import { ErrorSuccess, TStatus } from "../context/ErrorSuccess";
import { Alert, Snackbar } from "@mui/material";


export default function ProviderErrorSuccess({ children }: { children: ReactElement }) {

  const [mensagem, setMensagem] = useState<string>();
  const [status, setStatus] = useState<TStatus>('info');


  const setErrorSuccess = ({ mensagem, status }: { mensagem: string, status: TStatus }) => {
    setMensagem(mensagem);
    setStatus(status);
  }

  const setMensagemSuccess = (mensagem: string) => {
    setMensagem(mensagem);
    setStatus('success');
  }

  const setMensagemError = (mensagem: string) => {
    setMensagem(mensagem);
    setStatus('error');
  }

  const setMensagemInfo = (mensagem: string) => {
    setMensagem(mensagem);
    setStatus('info');
  }

  const handleClose = () => setMensagem(undefined)

  return (
    <ErrorSuccess.Provider value={{ setErrorSuccess, setMensagemSuccess, setMensagemError, setMensagemInfo }}>
      <Snackbar
        /*@ts-ignore*/
        open={mensagem}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={status}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {mensagem}
        </Alert>
      </Snackbar>

      {children}
    </ErrorSuccess.Provider>
  )
}
